(function () {
    'use strict';

    angular.module('swif.interventions')
    .service('openstcRightsService', openstcRightsService);

    function openstcRightsService (userService) {
        'ngInject';
        var service = {};

        service.getUserAbility = getUserAbility;

        function getUserAbility (container) {
            var user = userService.getAuthenticatedUserData();
            container = container ? container : {};
            container.is = {
                // if user can't read an intervention, he is a claimer
                claimer: !_.contains(user.access_rights, 'openstc_interventions_base')
            };
            return container;
        }
        return service;
    }

})();
